import React from 'react';

export default function VeteranSuccessModalContent() {
  return (
    <>
      <p>
        This program supports service members, Veterans, and qualified
        dependents through on-campus counseling and help overcoming
        barriers—like accommodating disabilities or getting referrals to health
        services. It's designed to help you succeed at school and get ready to
        enter the job market in a promising career field.
      </p>
      <p>
        <a
          href="http://www.benefits.va.gov/vocrehab/vsocfactsheet.asp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download the VSOC fact sheet
        </a>
      </p>
      <p>
        <a
          href="http://www.benefits.va.gov/vocrehab/vsoc.asp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more about the VSOC program
        </a>
      </p>
    </>
  );
}
